import(/* webpackChunkName: "mainSlider" */ '../../Styles/slider/mainSlider.scss');
import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');
import(/* webpackChunkName: "pagination" */ 'Feature/Common/code/Pagination/Styles/pagination.scss');

await import(/* webpackChunkName: "slick-carousel" */ 'slick-carousel');

window.am = window.am || {};

window.am.slider = new function () {
    var that = this;

    const isLotteryPagePresent = document.querySelector('.lottery-page');
    const sliderLottery = isLotteryPagePresent.querySelector('.main-slider');

    if (isLotteryPagePresent) {
        if (sliderLottery) {
            sliderLottery.classList.add('lottery-slider-draggable');
        }        
    }


    that.setHomeSlider = function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
            document.querySelectorAll('.home-slider')
                .forEach(element => {
                    var slidesToShow = 1;
                    var slidesPadding = '0 24px 0 24px';
                    //var slidesMarginLeft = "";

                    if (isLotteryPagePresent) {
                        slidesToShow = 1.1;                        
                        var slidesPadding = '0 0 0 37px';
                        if (element.querySelectorAll('.slick-slide').length < 2) {
                            slidesPadding = '0';
                            element.querySelector('.slick-track').classList.add("single-element");
                            element.querySelector('.slick-list').style.marginLeft = "-8px";
                        }
                    }

                    element.closest('.main-slider').style.padding = '16px';
                    element.querySelector('.slick-list').style.padding = slidesPadding;
                    $(element).slick('slickSetOption', 'slidesToShow', slidesToShow, true);
                });
        } else if (window.matchMedia("(max-width: 1024px)").matches) {
            document.querySelectorAll('.home-slider')
                .forEach(element => {
                    element.closest('.main-slider').style.paddingRight = '0';
                    element.querySelector('.slick-list').style.padding = '0 40px 0 0';
                    $(element).slick('slickSetOption', 'slidesToShow', 2, true);
                });
        } else {
            document.querySelectorAll('.home-slider')
                .forEach(element => {
                    element.closest('.main-slider').style.padding = '16px';
                    element.querySelector('.slick-list').style.padding = '0 0 0 0';
                    $(element).slick('slickSetOption', 'slidesToShow', 3, true);
                });
        }
    }

    that.setImageTeaserSlider = function (slider) {
        if (window.matchMedia("(max-width: 767px)").matches) {
            document.querySelectorAll('.image-teaser-slider')
                .forEach(element => {
                    element.querySelector('.slick-list').style.padding = '0 24px 0 24px';
                    $(element).slick('slickSetOption', 'slidesToShow', 1, true);
                });
        } else if (window.matchMedia("(max-width: 1024px)").matches) {
            document.querySelectorAll('.image-teaser-slider')
                .forEach(element => {
                    element.querySelector('.slick-list').style.padding = '0 0 0 0';
                    $(element).slick('slickSetOption', 'slidesToShow', 1, true);;
                });
        } else {
            document.querySelectorAll('.image-teaser-slider')
                .forEach(element => {
                    element.querySelector('.slick-list').style.padding = '0 0 0 0';
                    $(element).slick('slickSetOption', 'slidesToShow', 2, true);
                });
        }
    }

    that.init = function () {
        var isInEditor = document.querySelectorAll(".main-slider--in-editor").length > 0;
        if (!isInEditor) {
            var sliders = document.querySelectorAll(".main-slider__wrapper");

            sliders.forEach(function (slider) {
                $(slider).not('.slick-initialized').slick({
                    arrows: true,
                    dots: true,
                    appendDots: $(slider).parent().find(".pagination-dots"),
                    prevArrow: $(slider).parent().find(".pagination-prev"),
                    nextArrow: $(slider).parent().find(".pagination-next"),
                    slidesToShow: 3,
                });

                if (slider.classList.contains('main-slider--isloading')) {
                    slider.classList.remove('main-slider--isloading')
                }
            });

            that.setHomeSlider();
            that.setImageTeaserSlider();

            $(window).resize(function () {
                clearTimeout(window.resizedFinished);
                window.resizedFinished = setTimeout(function () {
                    that.setHomeSlider();
                    that.setImageTeaserSlider();
                }, 10);
            });
        }
    }
};

//window.am.slider.init();

window.addEventListener("load", window.am.slider.init);
